import jwtDecode from "jwt-decode";
import { LoggedUser } from "../features/users/types";

const enum STORAGE_NAME {
  SESSION = "sessionToken",
  MAP = "map_api",
  USER = "user",
}

const bearerKey = "Bearer ";

export const saveSessionToken = (token: string) => {
  if (!!localStorage && token) {
    const decodedToken = jwtDecode(token);

    localStorage.setItem(
      STORAGE_NAME.SESSION,
      token.includes(bearerKey) ? token : `${bearerKey}${token}`
    );
    localStorage.setItem(STORAGE_NAME.USER, JSON.stringify(decodedToken));
  }
};

export const loadSessionToken = () => {
  if (!!localStorage) {
    return localStorage.getItem(STORAGE_NAME.SESSION) || "";
  }
};

export const loadUser = () => {
  if (!!localStorage) {
    const userString = localStorage.getItem(STORAGE_NAME.USER);
    if (userString) {
      return JSON.parse(userString) as LoggedUser;
    }
  }
};

export const removeSessionToken = () => {
  if (!!localStorage) {
    localStorage.removeItem(STORAGE_NAME.SESSION);
    localStorage.removeItem(STORAGE_NAME.USER);
    localStorage.removeItem(STORAGE_NAME.MAP);
  }
};

export const saveMap = (map: JSON) => {
  if (!!localStorage) {
    localStorage.setItem(STORAGE_NAME.MAP, JSON.stringify(map));
  }
};
export const loadMap = (): JSON => {
  if (!!localStorage) {
    const rawMap = localStorage.getItem(STORAGE_NAME.MAP);
    return rawMap ? JSON.parse(rawMap) : "";
  }
  return JSON.parse("");
};
